import { Component, OnInit, OnDestroy, HostBinding } from '@angular/core';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { routerTransition } from 'app/shared/animations/router-transition.animation';
import { Subject } from 'rxjs/Rx';

import { NoticiasService } from './shared/noticias.service';

import { PesquisarNoticiaPayload, Tag } from 'models/noticia';

const POR_PAGINA = 10;

@Component({
  selector: 'app-noticias',
  templateUrl: './noticias.component.html',
  styleUrls: ['./noticias.component.scss'],
  animations: [routerTransition],
})
export class NoticiasComponent implements OnInit, OnDestroy {
  @HostBinding('@routerTransition') routerTransition = true;
  @HostBinding('style.display') display = 'block';

  configuracao = new Subject();
  situacaoModal = new Subject();

  query = {
    search: null,
    page: 1,
    tags: '',
  };

  loading: boolean;
  noticias = [];
  listenerRouter;
  tags: Tag[] = [];
  totalPaginas = 0;
  maisNoticias = false;

  constructor(
    private servico: NoticiasService,
    private activeRoute: ActivatedRoute,
    private router: Router,
  ) {
    this.listenerRouter = router.events.subscribe((ev) => (ev instanceof NavigationEnd) && this.recuperarNoticias());
  }

  ngOnInit() {
    this.maisNoticias = false;
    this.servico.tags().then((tags: Tag[]) => {
      this.tags = tags;
    });
  }

  ngOnDestroy() {
    this.listenerRouter.unsubscribe();
  }

  acaoPaginacao(pagina) {
    this.query.page = pagina.pagina;
    pagina.pagina === this.totalPaginas ? this.maisNoticias = true : this.maisNoticias = false;
    this.navegar(this.query);
  }

  acaoBuscar() {
    this.navegar({
      search: this.query.search,
      tags: this.query.tags,
    });
  }

  recuperarNoticias() {
    this.loading = true;
    this.query.search = this.activeRoute.snapshot.queryParams['search'];
    this.query.page = this.activeRoute.snapshot.queryParams['page'];
    this.query.tags = this.activeRoute.snapshot.queryParams['tags'];
    //console.log(this.query);
    this.pesquisar(this.query);
  }

  pesquisar(params) {
    if (params.tags) {
      params.tags = Number(params.tags);
    }
    this.situacaoModal.next(false);

    this.servico.query(params).then((resp: PesquisarNoticiaPayload) => {
      this.noticias = resp.data;
      this.totalPaginas = resp.totalPaginas;
      this.loading = false;

      this.configuracao.next({
        total: resp.total,
        porPagina: POR_PAGINA,
        atual: params.page || 1,
      });
      if (Number(params.page) === this.totalPaginas) {
        this.maisNoticias = true;
      }
    });
  }

  navegar(queryParams) {
    // limpar vazios
    if (queryParams) {
      if (queryParams.search === '') {
        queryParams.search = undefined;
      }
      if (queryParams.tags === '') {
        queryParams.tags = undefined;
      }
    }

    this.router.navigate([], {
      queryParams,
      relativeTo: this.activeRoute,
    });
  }
}
